import { selectors } from 'state/selectors';
import { metaSelectorOrderToBackend } from './orderToBackendPayload';
import { metaSelectorOrderToBlotterOrderData } from './orderToBlotterOrderData';

export const getOrderRequest = metaSelectorOrderToBackend(selectors);
export const getBlotterOrderData = metaSelectorOrderToBlotterOrderData(selectors);
